<script setup>
import { user, logoOutUser } from '@/modules/configuracoes/funcionario/store';
import { props } from '@/modules/configuracoes/filial/store';
import { props as propsCaixaAberto } from '@/modules/financeiro/financeiroCaixaMov/store/index';
import { useMenuState } from '@/composables/useMenuState';

const { toggleMenu, isMenuOpen } = useMenuState();
</script>

<template>
  <nav class="header-navbar navbar navbar-expand-lg align-items-center floating-nav navbar-shadow container-xxl navbar-light">
    <div class="navbar-container d-flex content">
      <div class="bookmark-wrapper d-flex align-items-center">
        <ul class="nav navbar-nav d-xl-none">
          <li class="nav-item">
            <a class="nav-link menu-toggle" :class="{ 'is-active': isMenuOpen }" href="#" @click.prevent="toggleMenu"><vue-feather type="menu"></vue-feather></a>
          </li>
        </ul>
      </div>
      <div class="ms-2">
        <ul class="nav navbar-nav align-items-center ms-auto ">
          <li class="nav-item d-sm-none d-lg-block text-sm-center">
            <a class="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <div class="user-nav align-items-center d-sm-flex d-none p-0 m-0">
                <span class="user-name fw-bolder">Caixa</span><span :class="`badge bg-${(propsCaixaAberto.isAberto ? 'secondary' : 'danger')}`">{{ propsCaixaAberto.abertoOrFechado }}</span>
              </div>
            </a>
          </li>
        </ul>
      </div>
      <ul class="nav navbar-nav align-items-center ms-auto ">
        <li class="nav-item dropdown dropdown-user">
          <a class="nav-link dropdown-toggle dropdown-user-link" id="dropdown-user" href="#" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="user-nav d-sm-flex d-none">
              <span class="user-name fw-bolder">{{ user?.apelido }}</span><span class="user-status">Filial: {{ props.filial.codigo }} - {{ props.filial.nome }}</span>
            </div>
            <span class="avatar"><img class="round" :src="user?.funcionarioFoto" alt="avatar" height="40" width="40" /><span class="avatar-status-online"></span></span>
          </a>
          <div class="dropdown-menu dropdown-menu-end" aria-labelledby="dropdown-user">
            <a class="dropdown-item" target="_blank" href="https://vrtech.app/publico/post/declaracao-de-privacidade/7d39741a-e60d-48d7-b0c8-ddd7ecb9ab47"><vue-feather type="file-text"></vue-feather> Privacidade</a><a class="dropdown-item" target="_blank" href="https://vrtech.app/publico/post/termos-e-condicoes-da-vr-system-para-o-e-trad/c410c3ce-c98d-4f34-a455-fea60ff43877"><vue-feather type="feather"></vue-feather> Termos</a>
            <router-link class="dropdown-item" :to="{name: 'sobre'}"><vue-feather type="file"></vue-feather> Sobre</router-link>
            <router-link class="dropdown-item" :to="{name: 'filial-selecionar'}"><a class="fa fa-building-circle-arrow-right" />Trocar filial</router-link>
            <a class="dropdown-item" @click.prevent="logoOutUser()"><vue-feather type="power"></vue-feather> Sair</a>
          </div>
        </li>
        <li class="nav-item d-sm-none d-lg-block">
          <a class="nav-link nav-link-style"><vue-feather type="moon"></vue-feather></a>
        </li>
        <li class="nav-item d-none d-lg-block">
          <a @click.prevent="logoOutUser()"><vue-feather type="log-out"></vue-feather></a>
        </li>
      </ul>
    </div>
  </nav>
</template>
